<template>
  <base-open-card :question="question" :question-name="`${questionType} משתנה`" :buttons="buttons"/>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseOpenCard from './BaseOpenCard.vue';

export default {
  name: 'VariableOpenCard',
  components: {
    BaseOpenCard,
  },
  props: {
    question: Object,
  },
  computed: {
    ...mapGetters('cashflowCategoryActions', ['CASHFLOW_CATEGORIES']),
    buttons() {
      return [
        {
          cashflowCategoryAnswer: this.CASHFLOW_CATEGORIES.variable,
          title: `זו באמת ${this.questionType} משתנה`,
        },
        {
          cashflowCategoryAnswer: this.CASHFLOW_CATEGORIES.fixed,
          variant: 'secondary',
          title: `זו ${this.questionType} קבועה`,
          subtitle: 'תצפה אותה גם בחודשים הבאים',
        },
      ];
    },
    isIncome() {
      return !!this.question.incomeAmount;
    },
    questionType() {
      return this.isIncome ? 'הכנסה' : 'הוצאה';
    },
  },
};
</script>

<style lang="scss" scoped></style>
